module.exports = __webpack_public_path__ + "static/media/Oct4-F19.12adac58.png";